import React from 'react'
import tw from 'tailwind-styled-components'

const TwHeadShadow = tw.div`
  absolute
  left-0
  right-0
  h-16
  -bottom-16
  text-grey-l60
  bg-radial-gradient-shadow
  pointer-events-none
`

const TwTableHead = tw.div`
  leading-none
  flex
  items-stretch
  text-secondary
  top-0
  bg-grey-l100
  text-12
  py-8
  px-16
`

export const TableHeadRow = ({
  children,
  className,
  onTop = true
}: {
  children: React.ReactNode
  className?: string
  onTop?: boolean
}) => {
  return (
    <>
      <TwTableHead className={className}>{children}</TwTableHead>
      {!onTop && <TwHeadShadow />}
    </>
  )
}
